import { useEffect, useCallback, useRef } from 'react';
export function createEventProvider() {
    const handlers = new Set();
    const dispatch = async (event) => {
        const promises = [];
        for (const handler of handlers) {
            try {
                const result = handler(event);
                if (result instanceof Promise) {
                    promises.push(result);
                }
                else {
                    promises.push(Promise.resolve());
                }
            }
            catch (error) {
                // Convert sync errors to rejected promises
                promises.push(Promise.reject(error));
            }
        }
        // Wait for all handlers to complete
        await Promise.all(promises);
    };
    const useHandler = (context, { onEvent }) => {
        const handlerRef = useRef();
        // Update the ref when onEvent changes
        handlerRef.current = onEvent;
        // Create a stable handler function that won't cause re-renders
        const stableHandler = useCallback((event) => {
            return handlerRef.current?.(event);
        }, []);
        useEffect(() => {
            handlers.add(stableHandler);
            return () => {
                handlers.delete(stableHandler);
            };
        }, [stableHandler]);
        return {};
    };
    return {
        dispatch,
        useHandler,
    };
}
//# sourceMappingURL=eventProvider.js.map